import {
    SET_SIMULATOR_LIST_REQUEST,
    SET_SIMULATOR_LIST_SUCCESS,
    SET_SIMULATOR_LIST_ERROR,
    SET_MODEL_LIST_REQUEST,
    SET_MODEL_LIST_SUCCESS,
    SET_MODEL_LIST_ERROR,
    SET_MODEL_VERSION_LIST_REQUEST,
    SET_MODEL_VERSION_LIST_SUCCESS,
    SET_MODEL_VERSION_LIST_ERROR,
    SET_FEATURE_LIST_REQUEST,
    SET_FEATURE_LIST_SUCCESS,
    SET_FEATURE_LIST_ERROR,
    SET_BASE_SCENARIO_LIST_REQUEST,
    SET_BASE_SCENARIO_LIST_SUCCESS,
    SET_BASE_SCENARIO_LIST_ERROR,
    SET_VARIATION_LIST_REQUEST,
    SET_VARIATION_LIST_SUCCESS,
    SET_VARIATION_LIST_ERROR,
    BASE_SCENARIO_SELECTED,
    DELETE_SCENARIO_SUCCESS,
    DELETE_SCENARIO_REQUEST,
    DELETE_SCENARIO_ERROR,
    SET_FUSION_LIST_REQUEST,
    SET_FUSION_LIST_SUCCESS,
    SET_FUSION_LIST_ERROR
} from "../../../../constants/CM/cm_open_loop/fusionDataCollection/dropDownModelConstants";
 
const initialSimulatorState = {
    simulatorListInfo: [],
    error: "",
    message: "",
};
 
export const dropDownSimulatorReducer = (state = initialSimulatorState, action) => {
    switch (action.type) {
        case SET_SIMULATOR_LIST_REQUEST:
            return {
                simulatorListInfo: [],
                error: "",
                message: "",
            };
        case SET_SIMULATOR_LIST_SUCCESS:
            return {
                simulatorListInfo: action.simulatorListInfo,
                error: "",
                message: "",
            };
        case SET_SIMULATOR_LIST_ERROR:
            return {
                simulatorListInfo: [],
                error: action.payload,
                message: "",
            };
        default:
            return state;
    }
};
 
const initialModelState = {
    modelListInfo: [],
    error: "",
    message: "",
};
 
export const dropDownModelReducer = (state = initialModelState, action) => {
    switch (action.type) {
        case SET_MODEL_LIST_REQUEST:
            return {
                modelListInfo: [],
                error: "",
                message: "",
            };
        case SET_MODEL_LIST_SUCCESS:
            return {
                modelListInfo: action.modelListInfo,
                error: "",
                message: "",
            };
        case SET_MODEL_LIST_ERROR:
            return {
                modelListInfo: [],
                error: action.payload,
                message: "",
            };
        default:
            return state;
    }
};
 
const initialModelVersionState = {
    modelVersionListInfo: [],
    error: "",
    message: "",
};
 
export const dropDownModelVersionReducer = (state = initialModelVersionState, action) => {
    switch (action.type) {
        case SET_MODEL_VERSION_LIST_REQUEST:
            return {
                modelVersionListInfo: [],
                error: "",
                message: "",
            };
        case SET_MODEL_VERSION_LIST_SUCCESS:
            return {
                modelVersionListInfo: action.modelVersionListInfo,
                error: "",
                message: "",
            };
        case SET_MODEL_VERSION_LIST_ERROR:
            return {
                modelVersionListInfo: [],
                error: action.payload,
                message: "",
            };
        default:
            return state;
    }
};
 
const initialFeatureState = {
    featureListInfo: [],
    error: "",
    message: "",
};
 
export const dropDownFeatureReducer = (state = initialFeatureState, action) => {
    switch (action.type) {
        case SET_FEATURE_LIST_REQUEST:
            return {
                featureListInfo: [],
                error: "",
                message: "",
            };
        case SET_FEATURE_LIST_SUCCESS:
            return {
                featureListInfo: action.featureListInfo,
                error: "",
                message: "",
            };
        case SET_FEATURE_LIST_ERROR:
            return {
                featureListInfo: [],
                error: action.payload,
                message: "",
            };
        default:
            return state;
    }
};
 
const initialBaseScenarioState = {
    baseScenarioListInfo: [],
    error: "",
    message: "",
};
 
export const dropDownBaseScenarioReducer = (state = initialBaseScenarioState, action) => {
    switch (action.type) {
        case SET_BASE_SCENARIO_LIST_REQUEST:
            return {
                baseScenarioListInfo: [],
                error: "",
                message: "",
            };
        case SET_BASE_SCENARIO_LIST_SUCCESS:
            return {
                baseScenarioListInfo: action.baseScenarioListInfo,
                error: "",
                message: "",
            };
        case SET_BASE_SCENARIO_LIST_ERROR:
            return {
                baseScenarioListInfo: [],
                error: action.payload,
                message: "",
            };
        default:
            return state;
    }
};
 
const initialSubmitState = {
    loading: "",
    variationListInfo: [],
    error: "",
    message: "",
};
 
export const dropDownSubmitReducer = (state = initialSubmitState, action) => {
    switch (action.type) {
        case SET_VARIATION_LIST_REQUEST:
            return {
                loading: true,
                variationListInfo: [],
                error: "",
                message: "",
            };
        case SET_VARIATION_LIST_SUCCESS:
            return {
                loading: false,
                variationListInfo: action.variationListInfo,
                error: "",
                message: "",
            };
        case SET_VARIATION_LIST_ERROR:
            return {
                loading: false,
                variationListInfo: [],
                error: action.payload,
                message: "",
            };
        default:
            return state;
    }
};
 


export const dropDownSubmitCarMakerFusionReducer = (state = initialSubmitState, action) => {
    switch (action.type) {
        case SET_FUSION_LIST_REQUEST:
            return {
                loading: true,
                variationListInfo: [],
                error: "",
                message: "",
            };
        case SET_FUSION_LIST_SUCCESS:
            return {
                loading: false,
                variationListInfo: action.variationListInfo,
                error: "",
                message: "",
            };
        case SET_FUSION_LIST_ERROR:
            return {
                loading: false,
                variationListInfo: [],
                error: action.payload,
                message: "",
            };
        default:
            return state;
    }
};
 
const defaultBaseScenarioSelected = {
    baseScenarioSelected: {},
};
 
 
 
 
//----------------------------------------------------------------------------------------------------------
 
export const baseScenarioSelectedReducer = (state = defaultBaseScenarioSelected, action) => {
    switch (action.type) {
        case BASE_SCENARIO_SELECTED:
            return {
                baseScenarioSelected: action.baseScenarioSelected,
            };
        default:
            return state;
    }
};


//------------------------------------deleteimplemenatation------------------------------------
 
export const DeleteScenarioReducer = (state = initialSubmitState, action) => {
    console.log("actrvffcrf=============================", action);
    switch (action.type) {
        case DELETE_SCENARIO_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case DELETE_SCENARIO_SUCCESS:
            // Filter out the deleted scenario from the state
            const updatedScenarioList = state.baseScenarioListInfo2.filter(scenario => scenario.id !== action.payload.scenarioId);
            return {
                ...state,
                loading: false,
                baseScenarioListInfo2: updatedScenarioList,
                currentPage: action.payload.currentPage, // Update currentPage
                error: "",
                message: action.message,
            };
        case DELETE_SCENARIO_ERROR:
            return {
                ...state,
                loading: false,
                error: action.error,
                message: "",
            };
        default:
            return state;
    }
};